export * from './lib/shared-tracking-data-access-google-tag-manager.module';
export * from './lib/google-tag-manager.resolver';
